import { useEffect, useState } from 'react';

export const useFormChanges = (initialData: any, currentData: any) => {
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    const hasChanged =
      JSON.stringify(initialData) !== JSON.stringify(currentData);
    setIsChanged(hasChanged);
  }, [initialData, currentData]);

  return isChanged;
};
